import { render } from "./CandidateNameCell.vue?vue&type=template&id=23c5a632&scoped=true"
import script from "./CandidateNameCell.vue?vue&type=script&lang=js"
export * from "./CandidateNameCell.vue?vue&type=script&lang=js"

import "./CandidateNameCell.vue?vue&type=style&index=0&id=23c5a632&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c5a632"]])

export default __exports__